import React, {useEffect, useState} from 'react';
import {MultiFilterButton} from "common";
import DatePicker from "react-datepicker";
import {DatePickerInput} from "../../../common/component/DatePickerInput";
import {tryFormatLocalDate} from "../../../common/util/date";
import {ProgressPortraitListFilterValue} from "./domain";
import {ProgressPortraitListAction} from "./progressPortraitListReducer";

export type ProgressPortraitListFilterParams = {
    clientGuid: string;
    reportDateFrom: string | null;
    reportDateTo: string | null;
}

export const asQueryParam = (filter: ProgressPortraitListFilterValue | undefined): ProgressPortraitListFilterParams => ({
    clientGuid: filter?.clientGuid ?? '',
    reportDateFrom: tryFormatLocalDate(filter?.reportDateFrom ?? null),
    reportDateTo: tryFormatLocalDate(filter?.reportDateTo ?? null),
});

function buildResetFilterValue(filterValue: ProgressPortraitListFilterValue): ProgressPortraitListFilterValue {
    return {
        clientGuid: filterValue.clientGuid,
        reportDateFrom: null,
        reportDateTo: null,
    };
}

type Props = {
    initFilterValue: ProgressPortraitListFilterValue;
    dispatch: React.Dispatch<ProgressPortraitListAction>;
}

export function ProgressPortraitListFilter({initFilterValue, dispatch}: Props) {
    const [filterValue, setFilterValue] = useState({...initFilterValue});

    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue]);

    const onFilterUpdate = (fieldName: 'reportDateFrom' | 'reportDateTo', fieldValue: Date | null) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue});
    };

    const dispatchSetFilterValue = (val: ProgressPortraitListFilterValue) => {
        dispatch({type: 'SET_FILTER', filter: val});
    };

    return <MultiFilterButton<ProgressPortraitListFilterValue>
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        dispatchSetFilterValue={dispatchSetFilterValue}
        filterOptions={[
            {
                label: "Report Date From",
                component: <DatePicker
                    wrapperClassName="w-full"
                    placeholderText="mm/dd/yyyy"
                    selected={filterValue.reportDateFrom}
                    onSelect={(date: Date) => onFilterUpdate("reportDateFrom", date)}
                    onChange={() => {}}
                    customInput={<DatePickerInput
                        fieldName="reportDateFrom"
                        value={undefined}
                        onFinish={(date) => onFilterUpdate("reportDateFrom", date)}
                    />}
                />
            },
            {
                label: "Report Date To",
                component: <DatePicker
                    wrapperClassName="w-full"
                    placeholderText="mm/dd/yyyy"
                    selected={filterValue.reportDateTo}
                    onSelect={(date: Date) => onFilterUpdate("reportDateTo", date)}
                    onChange={() => {}}
                    customInput={<DatePickerInput
                        fieldName="reportDateTo"
                        value={undefined}
                        onFinish={(date) => onFilterUpdate("reportDateTo", date)}
                    />}
                />
            },
        ]}
        emptyFilterValue={buildResetFilterValue(filterValue)}
    />;
}
